import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-product-collection-confirmation-modal',
  imports: [
    CommonModule,
    MatDialogModule,
  ],
  templateUrl: './product-collection-confirmation-modal.component.html',
  styleUrls: ['./product-collection-confirmation-modal.component.scss'],
  standalone: true,
})
export class ProductCollectionConfirmationModalComponent {
  dialogRef = inject(MatDialogRef<ProductCollectionConfirmationModalComponent>);

  onYes(): void {
    this.dialogRef.close(true);
  }

  onNo(): void {
    this.dialogRef.close(false);
  }

  hideModal(): void {
    this.dialogRef.close(false);
  }
}
